import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
function Toggle({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return <label className="relative inline-flex items-center cursor-pointer" data-id="element-618">
      <input type="checkbox" className="sr-only peer" checked={checked} onChange={onChange} data-id="element-619" />
      <div className="w-11 h-6 bg-surface2 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary" data-id="element-620" />
    </label>;
}
export function SettingsPrivacy() {
  const navigate = useNavigate();
  const [privateAccount, setPrivateAccount] = useState(false);
  const [downloads, setDownloads] = useState(true);
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-621">
      <div className="px-4 py-4 flex items-center border-b border-border sticky top-0 bg-black z-10" data-id="element-622">
        <button onClick={() => navigate(-1)} className="text-white mr-4" data-id="element-623">
          <ArrowLeftIcon size={24} data-id="element-624" />
        </button>
        <h1 className="text-white font-poppins font-bold text-lg" data-id="element-625">Privacy</h1>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar" data-id="element-626">
        <div className="bg-surface border-b border-border mt-6" data-id="element-627">
          <div className="px-4 py-4 flex items-center justify-between border-b border-border" data-id="element-628">
            <div data-id="element-629">
              <p className="text-white text-sm font-medium" data-id="element-630">Private account</p>
              <p className="text-softGray text-xs mt-0.5" data-id="element-631">
                Only approved followers can see your videos
              </p>
            </div>
            <Toggle checked={privateAccount} onChange={() => setPrivateAccount(!privateAccount)} data-id="element-632" />
          </div>

          <button className="w-full px-4 py-4 flex items-center justify-between hover:bg-surface2 transition-colors border-b border-border" data-id="element-633">
            <span className="text-white text-sm font-medium" data-id="element-634">
              Blocked users
            </span>
            <ChevronRightIcon size={16} className="text-softGray" data-id="element-635" />
          </button>

          <button className="w-full px-4 py-4 flex items-center justify-between hover:bg-surface2 transition-colors border-b border-border" data-id="element-636">
            <span className="text-white text-sm font-medium" data-id="element-637">
              Comment permissions
            </span>
            <div className="flex items-center gap-2 text-softGray" data-id="element-638">
              <span className="text-sm" data-id="element-639">Everyone</span>
              <ChevronRightIcon size={16} data-id="element-640" />
            </div>
          </button>

          <div className="px-4 py-4 flex items-center justify-between" data-id="element-641">
            <div data-id="element-642">
              <p className="text-white text-sm font-medium" data-id="element-643">Allow downloads</p>
              <p className="text-softGray text-xs mt-0.5" data-id="element-644">
                Others can download your videos
              </p>
            </div>
            <Toggle checked={downloads} onChange={() => setDownloads(!downloads)} data-id="element-645" />
          </div>
        </div>
      </div>
    </div>;
}